import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RequestBuilder } from '@/core/api/request-builder';
import { StrictHttpResponse } from '@/core/api/strict-http-response';
import { MedicoConflitoInteresseResponse } from '@/core/api/sicom-api/registro/medico/conflito-interesse/conflito-interesse.model';
import { SICOM_PATHS } from 'src/sicom-paths';

/**
 * Criar ou atualizar Conflito de Interesse
 * POST /api/v1/cadastro/medico/conflito-interesse
 * Body: MedicoConflitoInteresseResponse
 * - 201 quando criado
 * - 200 quando atualizado
 * - 409 quando não foi possível persistir
 */
export function conflitoInteresseUpsert(http: HttpClient, rootUrl: string, body: MedicoConflitoInteresseResponse, context?: HttpContext): Observable<StrictHttpResponse<unknown>> {
    const rb = new RequestBuilder(rootUrl, conflitoInteresseUpsert.PATH, 'post');

    if (body) {
        rb.body(body, 'application/json');
    }

    return http.request(rb.build({ responseType: 'json', accept: '*/*', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>): StrictHttpResponse<unknown> => r as unknown as StrictHttpResponse<unknown>)
    );
}

conflitoInteresseUpsert.PATH = SICOM_PATHS.registro.medico.conflitoInteresse.base;
